var _rect, _g, _path, _path2, _path3, _path4, _g2, _g3, _g4, _path5, _path6, _path7, _rect2, _g5, _g6, _g7, _g8, _g9, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesSupportStarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddi_7724_91924)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7724_91924)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 2.9751,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_7724_91924)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_7724_91924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.396 21.755L49.46 11.2269L32.997 29.4791L20.396 21.755Z",
    fill: "#FCE838"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_7724_91924)",
    style: {
      mixBlendMode: "plus-lighter"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.396 21.755L49.46 11.2269L32.997 29.4791L20.396 21.755Z",
    fill: "#FCE838"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_7724_91924)",
    style: {
      mixBlendMode: "lighten"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7219 19.2951L-1.70312 15.7251V16.7451L6.72833 27.6251L15.7219 25.2451V19.2951Z",
    fill: "#EE8C66"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_7724_91924)",
    style: {
      mixBlendMode: "lighten"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7219 19.2951L-1.70312 15.7251V16.7451L6.72833 27.6251L15.7219 25.2451V19.2951Z",
    fill: "#EE8C66"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_7724_91924)",
    style: {
      mixBlendMode: "lighten"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7219 19.2951L-1.70312 15.7251V16.7451L6.72833 27.6251L15.7219 25.2451V19.2951Z",
    fill: "#EE8C66"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_7724_91924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0554 21.7324L9.77344 30.4087L11.4471 30.6678L30.9561 28.795L28.8183 23.2441L19.0554 21.7324Z",
    fill: "#1F2647"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_7724_91924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0554 21.7324L9.77344 30.4087L11.4471 30.6678L30.9561 28.795L28.8183 23.2441L19.0554 21.7324Z",
    fill: "#1F2647"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_7724_91924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0469 11.9001L33.1469 14.5776L17.7821 17.8501L11.0469 11.9001Z",
    fill: "#A5C9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_7724_91924)",
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0469 11.9001L33.1469 14.5776L17.7821 17.8501L11.0469 11.9001Z",
    fill: "#A5C9FF"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M4.8268 39.41L16.7734 26.8799L-3.87632 16.5225L-1.78723 26.4089L-1.55973 35.873L4.8268 39.41Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9388 14.8046L23.7969 41.2546L24.9888 41.6393L42.0434 32.2925L43.8919 17.0485L36.9388 14.8046Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 0.846874,
    y: 1.6999,
    width: 42.5016,
    height: 26.3502
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_1_7724_91924_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 20,
    x: 2.25,
    y: 0.975098,
    width: 80,
    height: 80,
    fill: "url(#paint0_radial_7724_91924)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_7724_91924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1727 17.9753C28.1748 18.2367 28.0953 18.4924 27.9453 18.7066C27.7954 18.9208 27.5824 19.083 27.336 19.1706C27.336 19.1706 23.7659 19.5234 22.2806 21.009C20.7956 22.4943 20.443 26.0635 20.443 26.0635C20.3525 26.3076 20.1894 26.518 19.9757 26.6666C19.762 26.8152 19.508 26.8949 19.2477 26.8949C18.9875 26.8949 18.7334 26.8152 18.5197 26.6666C18.3061 26.518 18.143 26.3076 18.0524 26.0635C18.0524 26.0635 17.7002 22.4935 16.2148 21.0082C14.7295 19.5228 11.1594 19.1706 11.1594 19.1706C10.9154 19.08 10.705 18.9169 10.5564 18.7033C10.4078 18.4896 10.3281 18.2355 10.3281 17.9753C10.3281 17.715 10.4078 17.461 10.5564 17.2473C10.705 17.0336 10.9154 16.8705 11.1594 16.78C11.1594 16.78 14.7295 16.4277 16.2148 14.9424C17.7002 13.457 18.0524 9.88698 18.0524 9.88698C18.143 9.64298 18.3061 9.43253 18.5197 9.28393C18.7334 9.13532 18.9875 9.05566 19.2477 9.05566C19.508 9.05566 19.762 9.13532 19.9757 9.28393C20.1894 9.43253 20.3525 9.64298 20.443 9.88698C20.443 9.88698 20.7959 13.457 22.2814 14.9424C23.7667 16.4274 27.336 16.78 27.336 16.78C27.5824 16.8675 27.7954 17.0297 27.9453 17.2439C28.0953 17.4582 28.1748 17.7138 28.1727 17.9753Z",
    fill: "#1F2647"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_7724_91924)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_7724_91924)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.1758,
    y: 26.1011,
    width: 1.13333,
    height: 1.13333,
    transform: "rotate(-45 13.1758 26.1011)",
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 13.5742,
    y: 26.1011,
    width: 0.566667,
    height: 0.566667,
    transform: "rotate(-45 13.5742 26.1011)",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_7724_91924)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_7724_91924)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.75,
    y: 26.1011,
    width: 1.13333,
    height: 1.13333,
    transform: "rotate(-45 29.75 26.1011)",
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.1484,
    y: 26.1011,
    width: 0.566667,
    height: 0.566667,
    transform: "rotate(-45 30.1484 26.1011)",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_7724_91924)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_7724_91924)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.75,
    y: 15.0513,
    width: 1.13333,
    height: 1.13333,
    transform: "rotate(-45 29.75 15.0513)",
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.1484,
    y: 15.0513,
    width: 0.566667,
    height: 0.566667,
    transform: "rotate(-45 30.1484 15.0513)",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_f_7724_91924)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_7724_91924)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.7266,
    y: 9.10107,
    width: 1.13333,
    height: 1.13333,
    transform: "rotate(-45 15.7266 9.10107)",
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.125,
    y: 9.10107,
    width: 0.566667,
    height: 0.566667,
    transform: "rotate(-45 16.125 9.10107)",
    fill: "white"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.4625,
    y: 3.1876,
    width: 29.575,
    height: 29.575,
    rx: 14.7875,
    stroke: "url(#paint1_linear_7724_91924)",
    strokeWidth: 0.425
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddi_7724_91924",
    x: -1.19209e-7,
    y: 0.0000975728,
    width: 38.5,
    height: 38.925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.85,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_7724_91924"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7724_91924"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.425,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_7724_91924"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.85
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_7724_91924",
    result: "effect2_dropShadow_7724_91924"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.425,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect3_dropShadow_7724_91924"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.782621 0 0 0 0 0.782621 0 0 0 0 0.782621 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_7724_91924",
    result: "effect3_dropShadow_7724_91924"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_7724_91924",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.85,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect4_innerShadow_7724_91924"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect4_innerShadow_7724_91924"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_7724_91924",
    x: -8.975,
    y: 6.12705,
    width: 63.5359,
    height: 40.6124,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.55,
    result: "effect1_foregroundBlur_7724_91924"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_7724_91924",
    x: 15.2945,
    y: 6.12705,
    width: 39.2664,
    height: 28.452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.55,
    result: "effect1_foregroundBlur_7724_91924"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_7724_91924",
    x: 10.1945,
    y: 1.02705,
    width: 49.4664,
    height: 38.652,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.1,
    result: "effect1_foregroundBlur_7724_91924"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_7724_91924",
    x: -6.80313,
    y: 10.6251,
    width: 27.6258,
    height: 22.0999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.55,
    result: "effect1_foregroundBlur_7724_91924"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_7724_91924",
    x: -11.9031,
    y: 5.5251,
    width: 37.8258,
    height: 32.2999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.1,
    result: "effect1_foregroundBlur_7724_91924"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_7724_91924",
    x: -15.3031,
    y: 2.1251,
    width: 44.6258,
    height: 39.0999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.8,
    result: "effect1_foregroundBlur_7724_91924"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_7724_91924",
    x: -0.426563,
    y: 11.5324,
    width: 41.5836,
    height: 29.3355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.1,
    result: "effect1_foregroundBlur_7724_91924"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_7724_91924",
    x: 4.67344,
    y: 16.6324,
    width: 31.3836,
    height: 19.1355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.55,
    result: "effect1_foregroundBlur_7724_91924"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_7724_91924",
    x: 5.94687,
    y: 6.7999,
    width: 32.3016,
    height: 16.1502,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.55,
    result: "effect1_foregroundBlur_7724_91924"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_7724_91924",
    x: 0.846874,
    y: 1.6999,
    width: 42.5016,
    height: 26.3502,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.1,
    result: "effect1_foregroundBlur_7724_91924"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_7724_91924_clip_path",
    transform: "translate(-0.846874 -1.6999)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 0.975098,
    width: 80,
    height: 80
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_7724_91924",
    x: 6.50312,
    y: 6.50566,
    width: 25.4938,
    height: 25.4894,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.275
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7724_91924"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7724_91924",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_7724_91924",
    x: 12.7508,
    y: 24.8748,
    width: 2.45156,
    height: 2.45254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2125,
    result: "effect1_foregroundBlur_7724_91924"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_7724_91924",
    x: 12.7508,
    y: 24.8748,
    width: 2.45156,
    height: 2.45254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2125,
    result: "effect1_foregroundBlur_7724_91924"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_7724_91924",
    x: 29.325,
    y: 24.8748,
    width: 2.45156,
    height: 2.45254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2125,
    result: "effect1_foregroundBlur_7724_91924"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_7724_91924",
    x: 29.325,
    y: 24.8748,
    width: 2.45156,
    height: 2.45254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2125,
    result: "effect1_foregroundBlur_7724_91924"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_7724_91924",
    x: 29.325,
    y: 13.825,
    width: 2.45156,
    height: 2.45254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2125,
    result: "effect1_foregroundBlur_7724_91924"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_7724_91924",
    x: 29.325,
    y: 13.825,
    width: 2.45156,
    height: 2.45254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2125,
    result: "effect1_foregroundBlur_7724_91924"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_7724_91924",
    x: 15.3016,
    y: 7.8748,
    width: 2.45156,
    height: 2.45254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2125,
    result: "effect1_foregroundBlur_7724_91924"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_7724_91924",
    x: 15.3016,
    y: 7.8748,
    width: 2.45156,
    height: 2.45254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2125,
    result: "effect1_foregroundBlur_7724_91924"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7724_91924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.25 40.9751) rotate(90) scale(58 50.1543)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDEAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7724_91924",
    x1: 19.25,
    y1: 2.9751,
    x2: 19.25,
    y2: 32.9751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7724_91924"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 2.9751,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesSupportStarLogo);
export default __webpack_public_path__ + "static/media/sales-support-star-logo.3344f7ed17e3ce4fdcb14581b7a041c8.svg";
export { ForwardRef as ReactComponent };